import { LAYOUT } from '../constants';
export const typeHeader = ({ path }) => {
	const routes = [
		{
			path: '/checkout/retirement',
			type: 'checkout',
		},
		{
			path: '/checkout/payment',
			type: 'checkout',
		},
		{
			path: '/checkout/prescription',
			type: 'checkout',
		},
		{
			path: '/checkout/detail',
			type: 'checkout',
		},
		{
			path: '/auth/login',
			type: 'auth',
		},
		{
			path: '/auth/register',
			type: 'auth',
		},
		{
			path: '/auth/recover-password',
			type: 'auth',
		},
		{
			path: '/auth/token',
			type: 'auth',
		},
	];

	let isHeader = LAYOUT.MAIN;

	for (let i = 0; i < routes.length; i++) {
		if (path.includes(routes[i].path)) {
			console.log(`La palabra '${routes[i]}' fue encontrada.`);
			isHeader = routes[i].type;
			break; // Rompe el ciclo una vez que se encuentra una coincidencia
		}
	}

	return isHeader;
};
